import { DataAccessUtils } from './DataAccessUtils';
import { SectionNameTypes } from './ScoreUtils';
import { useStore } from './Store';

type CagrType = 'organic' | 'projected';
export class DataAccessAggregateUtils {
    private companies: DataAccessUtils[] = [];

    constructor(private industry: string, private subIndustry: string) {
        const store = useStore();

        const allDeals = Object.keys(store.reportDataDB);

        allDeals.forEach(deal => {
            const q = store.createDataAccess(deal);
            if (q) {
                const industry = q.value('industry');
                const subIndustry = q.value('industrySubType');
                if (industry === this.industry && subIndustry === this.subIndustry) {
                    this.companies.push(q);
                }
            }
        });
    }

    value(fieldName: string) {
        if (fieldName == 'company_name') {
            return this.industry;
        }

        if (fieldName == 'industry') {
            return this.industry;
        }

        if (fieldName == 'industrySubType') {
            return this.subIndustry;
        }

        return 'N/A';
    }

    scoreBySection(section: SectionNameTypes) {
        var valuesUsed = 0;
        var valuesTotalAccumlated = 0;
        this.companies.forEach(company => {
            const val = company.scoreBySection(section);
            if (val != null) {
                valuesUsed++;
                valuesTotalAccumlated += val;
            }
        });

        return valuesUsed > 0 ? (valuesTotalAccumlated / valuesUsed).toFixed(2) : -1;
    }
    score() {
        var valuesUsed = 0;
        var valuesTotalAccumlated = 0;
        this.companies.forEach(company => {
            const val = company.score();
            if (val != -1) {
                valuesUsed++;
                valuesTotalAccumlated += val;
            }
        });

        return valuesUsed > 0 ? (valuesTotalAccumlated / valuesUsed).toFixed(2) : -1;
    }

    returnYearsAverageCagr(cagr: CagrType) {
        var ret = {}
        for (var year = 3; year <= 5; year++) {
            var valuesUsed = [];
            this.companies.forEach(company => {
                const val = (cagr == 'organic' ? company.organicCagr(year) : company.projectedCagr(year));
                if (val != 'N/A' && !isNaN(val)) {
                    valuesUsed.push(val);
                }
            });
            ret[year] = this.trimmedAverage(valuesUsed);
        }
        return ret;
    }

    trimmedAverage(values: number[]): number | string {
        if (values.length == 0) {
            return "N/A";
        }

        if (values.length < 4) {
            return values.reduce((acc, val) => acc + val, 0) / values.length;

        }

        const sorted = [...values].sort((a, b) => a - b);
        const count = sorted.length;

        const lower = Math.floor(count * 0.25);
        const upper = Math.ceil(count * 0.75);

        const middle = sorted.slice(lower, upper); // middle 50%
        const sum = middle.reduce((acc, val) => acc + val, 0);

        return sum / middle.length;
    }


    get_extended_value_float(fieldName: string) {
        if (fieldName == 'recurring_revenue_summary') {
            return 'N/A';
        }

        if (fieldName == 'organic_cagr_N_years' || fieldName == 'projected_organic_cagr_N_years') {
            const cagrType = fieldName == 'organic_cagr_N_years' ? 'organic' : 'projected';
            return this.returnYearsAverageCagr(cagrType);
        }
        var valuesUsed = [];
        this.companies.forEach(company => {
            const val = company.get_extended_value_float(fieldName);
            if (val != 'N/A' && !isNaN(val)) {
                valuesUsed.push(val);
            }
        });

        return this.trimmedAverage(valuesUsed);
    }
}